module.exports = __webpack_public_path__ + "img/DataArrayOutlined.b07bcb36.svg";